import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, IconButton, Typography, Tab, Tabs } from "@mui/material";

import APP_ROUTES from "../../../../routers/routeConstants";

import { ServiceDetailsBackIcon } from "../../assets/icons/service-details-icons";

const ServiceRequestHeader = ({ serviceId, serviceName }: { serviceId?: number; serviceName?: string }) => {
  const { t, i18n } = useTranslation("goService", { keyPrefix: "serviceRequestPage" });
  const navigate = useNavigate();
  const handleBack = () => navigate(APP_ROUTES.MY_SERVICES);

  return (
    <Box sx={styles.container}>
      <Box sx={styles.headerWrapper}>
        <Typography sx={styles.title}>
          <IconButton size="small" onClick={handleBack}>
            <ServiceDetailsBackIcon />
          </IconButton>
          {t("title", { serviceName })}
        </Typography>
      </Box>
      <ServiceRequestHeaderTabsNavigation />
    </Box>
  );
};

export default ServiceRequestHeader;

const TABS = ["details", "chat", "contract"] as const;
type TabType = (typeof TABS)[number];

const ServiceRequestHeaderTabsNavigation = () => {
  const { t } = useTranslation("goService", { keyPrefix: "serviceRequestPage" });

  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get("tab") || TABS[0];

  const handleTabChange = (event: React.SyntheticEvent, newValue: TabType) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("tab", newValue);

    navigate({ search: searchParams.toString() });
  };

  return (
    <Tabs
      value={currentTab}
      onChange={handleTabChange}
      aria-label="service request tabs"
      sx={{
        minHeight: "fit-content",
        "& .MuiTabs-flexContainer": {
          gap: "24px",
        },
      }}
    >
      {TABS.map((tab) => {
        return <Tab key={tab} label={t(tab)} value={tab} sx={styles.tabStyle(tab === currentTab)} />;
      })}
    </Tabs>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    padding: "20px 20px 0",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "var(--White, #FFF)",
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "normal",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  tabStyle: (isActive: boolean) => ({
    color: isActive ? "var(--Brand-700, #076D0D)" : "var(--Gray-500, #667085)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    padding: "0px 4px 12px 4px",
    textTransform: "none",
    minHeight: "fit-content",
    minWidth: "fit-content",
  }),
  headerWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: { xs: "flex-start", sm: "center" },
    flexDirection: { xs: "column", sm: "row" },
    gap: { xs: "16px", sm: "0" },
  },
  viewServiceDetailsButton: {
    width: { xs: "100%", sm: "auto" },
  },
};
